import React from 'react';
import Head from 'next/head';

import iconExperience from './assets/iconExperience.svg';
import iconLegibility from './assets/iconLegibility.svg';
import iconAccessibility from './assets/iconAccessibility.svg';
import iconControl from './assets/iconControl.svg';
import iconVisibility from './assets/iconVisibility.svg';
import iconSecurity from './assets/iconSecurity.svg';
import iconSupport from './assets/iconSupport.svg';
import iconValue from './assets/iconValue.svg';

import styles from './features.module.scss';

const Features = () => (
  <div className={ styles.content }>
    <Head>
      <title>Deal Roadshow | Features</title>
      <meta
        name="description"
        content="Learn more about Deal Roadshow, the leading internet roadshow offering unparalleled analytics and fanatical 24x7 support."
      />
    </Head>
    <h1 className={ styles.title }>
      Deal Roadshow delivers an exceptional user experience with unparalleled insight into the syndication process
    </h1>
    { /* INVESTORS SECTION */ }

    <h2 className={ styles.subtitle }>Investors</h2>
    <div className={ styles.caption }>
      An electronic roadshow that is easy to use, easy to read and accessible from any device.
    </div>

    <div className={ styles.featureGroupWrp }>
      <div className={ styles.featureGroup }>
        <div className={ styles.feature }>
          <img src={ iconExperience.src } alt="Better Experience" />
          <h3 className={ styles.featureTitle }>Better Experience</h3>
          <div className={ styles.featureText }>
            Clean & intuitive interface<br />
            Seamless audio & video streaming<br />
            No popup windows
          </div>
        </div>
        <div className={ styles.feature }>
          <img src={ iconLegibility.src } alt="Better Legibility" />
          <h3 className={ styles.featureTitle }>Better Legibility</h3>
          <div className={ styles.featureText }>
            HD document rendering<br />
            Crystal-clear text<br />
            No blurriness
          </div>
        </div>
        <div className={ styles.feature }>
          <img src={ iconAccessibility.src } alt="Better Accessibility" />
          <h3 className={ styles.featureTitle }>Better Accessibility</h3>
          <div className={ styles.featureText }>
            Works on all devices & browsers<br />
            No plugins or apps required<br />
            Keyboard shortcuts
          </div>
        </div>
      </div>
    </div>

    { /* UNDERWRITERS & ISSUERS SECTION */ }
    <h2 className={ styles.subtitle }>Underwriters & Issuers</h2>
    <div className={ styles.caption }>
      A trusted electronic roadshow platform that is better for you, your clients and your investors.
    </div>

    <div className={ styles.featureGroupWrp }>
      <div className={ styles.featureGroup }>
        <div className={ styles.feature }>
          <img src={ iconControl.src } alt="Better Control" />
          <h3 className={ styles.featureTitle }>Better Control</h3>
          <div className={ styles.featureText }>
            Ability to manage deals online 24/7<br />
            Publish changes instantly<br />
            Upload streaming media
          </div>
        </div>
        <div className={ styles.feature }>
          <img src={ iconVisibility.src } alt="Better Visibility" />
          <h3 className={ styles.featureTitle }>Better Visibility</h3>
          <div className={ styles.featureText }>
            Real-time analytics<br />
            "Client-ready" reports<br />
            Engagement metrics
          </div>
        </div>
        <div className={ styles.feature }>
          <img src={ iconSecurity.src } alt="Better Security" />
          <h3 className={ styles.featureTitle }>Better Security</h3>
          <div className={ styles.featureText }>
            Watermarking & screenshot prevention<br />
            256-bit AES SSL/TLS encryption<br />
            Internal and external firewalls
          </div>
        </div>
      </div>
    </div>
    <div className={ styles.featureGroupWrp }>
      <div className={ styles.featureGroup }>
        <div className={ styles.feature }>
          <img src={ iconSupport.src } alt="Better Support" />
          <h3 className={ styles.featureTitle }>Better Support</h3>
          <div className={ styles.featureText }>
            Unlimited 24/7/365 support<br />
            In-screen live-chat for investors
          </div>
        </div>
        <div className={ styles.feature }>
          <img src={ iconValue.src } alt="Better Value" />
          <h3 className={ styles.featureTitle }>Better Value</h3>
          <div className={ styles.featureText }>
            Up to 20% less than the competition
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Features;
